"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseSession = void 0;
const helpers_1 = require("../../../core/helpers");
/**
 *
 * @deprecated please use from web-ui-security instead
 * @link https://github.com/santander-group-ods/SOFTWEB-web-ui-security | web-ui-security
 *
 */
class BaseSession {
    constructor(sessionStorage) {
        this.sessionStorage = sessionStorage;
    }
    updateData(newData) {
        if (!this.sessionStorage.getSavedSessionData()) {
            helpers_1.Log.warn('Try to init session before update it');
        }
        this.sessionStorage.saveSessionData(newData);
    }
    refresh() {
        return __awaiter(this, void 0, void 0, function* () {
            const newData = yield this.doRefresh();
            this.updateData(newData);
            return Promise.resolve();
        });
    }
    initSession(initData) {
        if (!this.sessionStorage.getSavedSessionData()) {
            if (!initData || !this.isDataValid(initData)) {
                helpers_1.Log.warn('Incorrect initialization session data');
            }
            else {
                this.sessionStorage.saveSessionData(initData);
            }
        }
        else {
            helpers_1.Log.warn('Session already initialized');
        }
    }
    finishSession() {
        this.sessionStorage.removeSavedSessionData();
    }
    getData() {
        return this.sessionStorage.getSavedSessionData();
    }
    isValid() {
        const actualData = this.getData();
        return actualData ? this.isDataValid(actualData) : false;
    }
}
exports.BaseSession = BaseSession;
//# sourceMappingURL=index.js.map